import React from "react";
import { capitalize } from "../../utils/textFunctions";

const LivingArrangement = ({ data }) => (
  <div>
    <h4>Living Arrangement</h4>
    {data.map((livingArrangement, index) => (
      <div key={index}>
        {livingArrangement.valueCoding.display
          ? capitalize(livingArrangement.valueCoding.display)
          : livingArrangement.valueCoding.code}
      </div>
    ))}
  </div>
);

export default LivingArrangement;
